<template>
  <div class="container">
    <div class="cart-heading">
      <div class="cart-h1">
        Order Received
        <span class="d-block d-md-inline">
          <span class="d-none d-md-inline" aria-hidden="true">|</span>
          <a :href="orderDetailsUrl(orderId)">
            Order #{{orderId}}
          </a>
        </span>
      </div>
      <div class="cart-actions">
        <!-- <a class="mr-1" href="#"><span class="fa fa-envelope"></span> Email</a> -->
        <a onClick="javascript:window.print();" class="d-none d-md-inline-block btn-print-order">
          <span class="fa fa-print"></span> Print
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <reminder-banner class="mb-4" v-if="isPayAtPickup">
          <span class="reminder-banner__text--bold">Don't forget! </span>
          Bring your EBT and credit/debit cards with you. We don't accept cash, checks, or WIC.
        </reminder-banner>
        <order-details
          v-bind="isCurbside ? curbsideExperience : deliveryExperience"
        ></order-details>
      </div>
      <div class="col-md-3">
        <section v-if="$store.state.cart.priceInfo" class="cart-total-section mb-3">
          <cart-total-card v-bind:cartTotalCardInfo="cartTotalCardInfo"></cart-total-card>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="forgotten-product">
          <h5>
            <strong>Forgot something?</strong>
          </h5>
          <p>
            We’re processing your order, which should take just a moment. Once that’s done,
            <a
              :href="orderDetailsUrl(orderId)"
            >visit your order details</a>
            to add items up to 3&nbsp;hours before your scheduled&nbsp;{{ $store.state.cart.curbsideFulfillmentMode }}&nbsp;time.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash';
import CartTotalCard from "../../../shared/components/cart/CartTotalCard";
import OrderDetails from "../../../shared/components/OrderDetails";
import ReminderBanner from "../../../shared/components/ReminderBanner";
import orderDetailsUrl from '../../../shared/components/mixins/orderDetailsUrl';

export default {
  name: "OrderConfirmation",
  components: {
    "cart-total-card": CartTotalCard,
    "order-details": OrderDetails,
    "reminder-banner": ReminderBanner,
  },
  mixins: [orderDetailsUrl],
  data() {
    return {
      curbsideExperience: {
        thankYouMessage: "Thank you for Shopping with H&#8209;E&#8209;B!",
        experienceMessage: "Your Order has been sent to the store.",
        experienceType: "Curbside Pickup",
        nextStepsMessage:
          'Once you arrive at H&#8209;E&#8209;B, send a text to <a href="sms:99147"><strong>99147</strong></a> with your parking spot number and your Personal Shopper will be right out with your order.',
        readFaqs: "Read Curbside FAQs",
        deliveryLocation: "Nogalitos H&#8209;E&#8209;B"
      },
      deliveryExperience: {
        thankYouMessage: "Thank you for Shopping with H&#8209;E&#8209;B!",
        experienceMessage:
          "Our H&#8209;E&#8209;B Personal Shoppers have received your order and will get started on selecting your groceries soon. Please review your order details below. We&#39;ll let you know when your groceries are ready. In the meantime, relax and enjoy all that time you&#39;re saving!",
        experienceType: "Home Delivery",
        nextStepsMessage:
          "You will receive a text message and/or an email when your order has arrived at your destination.",
        readFaqs: "Read Delivery FAQs",
        deliveryLocation: "Home"
      },
      cartTotalCardInfo: {
        showSubTotal: false,
        showPersonalShoppersFee: true,
        showSubmitBtn: false,
        showPromoCodeInput: false,
        showDesclaimerText: false,
        showAllSavingsSection: true,
        showTotalSavingsSection: true,
        showViewMyOrder: true,
        showTaxAmount: true,
        showPriceTotal: true,
        priceTotalText: "Total",
        taxTotalText: "Tax",
        gratuityText: "Driver Tip"
      },
      isUserGuest: window.heb.data.user.isGuest,
      orderId: window.heb.data.cart.order.id
    };
  },
  computed: {
    productSize() {
      return window.heb.screen.isSmall ? "small" : "normal";
    },
    isCurbside() {
      return get(this.$store.state.cart, "curbsideFulfillmentMode", "") === "pickup";
    },
    isPayAtPickup() {
      const paymentGroups = get(this.$store.state.cart, "paymentGroups", []);
      return this.isCurbside && paymentGroups.some(group => group.paymentMethod === "payAtPickupPayment");
    },
  },
  mounted: function() {
    if (this.isUserGuest) {
      window.location.href = window.heb.data.user.loginURL;
    }

    if (this.isPayAtPickup) {
      this.curbsideExperience.nextStepsMessage = 'When you arrive, send a text to <a href="sms:99147"><strong>99147</strong></a> with your parking spot number. Your Personal Shopper will swipe your cards and issue a final receipt when you pick up your order.';
    }

    if (this.$store.state.cart.commerceItemCount === 0) {
      // User does not have an order, maybe they hit refresh or clicked submit twice.
      // Forward to homepage HUP-1990
      window.location.href = "/";
    }

    document.getElementById("header").style.display = "block";
  }
};
</script>

<style lang="scss" scoped>
@import "../../../shared/assets/_lib.scss";

.cart-actions {
  font-weight: 600;
  font-size: 14px;
}

.cart-h1 span {
  font-size: 1rem;
  font-weight: 400;
}

.forgotten-product {
  margin: 1em auto;
  text-align: center;
  max-width: 600px;
  a {
    font-weight: bold;
  }
}

@media screen and (min-width: $breakpoint-tablet) {
  .order-confirmation-heading {
    border-bottom: 1px solid $color-border-standard-gray;
    margin-bottom: 30px;
    padding-bottom: 14px;

    h1 {
      font-size: 25px;
      font-weight: $font-weight-boldish;
    }
  }

  .btn-print-order {
    cursor: pointer;
  }
}

@media print {
  #header {
    display: none !important;
  }
}
</style>

<docs>
    The Vue component for the order confirmation page.

    ```jsx

        data: {
          curbsideExperience: {
            thankYouMessage: 'Thank you for Shopping with H&#8209;E&#8209;B!',
            experienceMessage: 'Your Order has been sent to the store.',
            experienceType: 'Curbside Pickup',
            nextStepsMessage: ' Once you arrive at H&#8209;E&#8209;B, send a text to <a href="sms:99147"><strong>99147</strong></a> with your parking spot number and your Personal Shopper will be right out with your order.',
            readFaqs: 'Read Curbside FAQs',
            deliveryLocation: 'Nogalitos H&#8209;E&#8209;B'
          },
          deliveryExperience: {
            thankYouMessage: 'Thank you for Shopping with H&#8209;E&#8209;B!',
            experienceMessage: 'We have received your order.',
            experienceType: 'Home Delivery',
            nextStepsMessage: 'You will receive a text message and/or an email when your order has arrived at your destination.',
            readFaqs: 'Read Delivery FAQs',
            deliveryLocation: 'Home'
          },
          cartTotalCardInfo: {
            showSubTotal: false,
            showPersonalShoppersFee: true,
            showSubmitBtn: false,
            showSavingsDropdown: false,
            showPromoCodeInput: false,
            showDesclaimerText: false,
            showAllSavingsSection: true,
            showTotalSavingsSection: true,
            priceTotalText: 'Total',
            taxTotalText: 'Tax'
          }
        }

        <order-details v-bind="$store.state.cart.curbsideFulfillmentMode === 'curbside' ? curbsideExperience : deliveryExperience"></order-details>

        <cart-total v-bind="cartTotalCardInfo"></cart-total>

    ```

    The order confirmation page takes in the order details and cart total components displaying specific information (shown above) to display content to the user depending on their experince, curbside or delivery, and show cart total info based off of what page the user is on. In this case the user is on the order confirmation page, so cartTotalCardInfo content will be displayed to the user.

</docs>
